module.exports = __webpack_public_path__ + "img/text_havies_de_ser_es.4bee71b2.png";